"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsEmailValid = exports.getFormatedPayloadBody = exports.getFormattedEmailStakeholders = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const HelperUtils_1 = require("utils/HelperUtils");
const getFormattedEmailStakeholders = (get) => {
    const { payloadBody, isToggleNotificationStakeholdersOn } = get();
    const { emailStakeholders } = payloadBody || {};
    if (isToggleNotificationStakeholdersOn && !(0, isEmpty_1.default)(emailStakeholders)) {
        return emailStakeholders?.split(',').map((email) => email.trim());
    }
    return [];
};
exports.getFormattedEmailStakeholders = getFormattedEmailStakeholders;
const getFormatedPayloadBody = (get) => {
    const { payloadBody, getFormattedEmailStakeholders } = get();
    const newPayloadBody = {
        ...(0, cloneDeep_1.default)(payloadBody),
        emailStakeholders: getFormattedEmailStakeholders()
    };
    return newPayloadBody;
};
exports.getFormatedPayloadBody = getFormatedPayloadBody;
const checkIsEmailValid = (get) => {
    const { getFormatedPayloadBody, isToggleNotificationStakeholdersOn } = get();
    const { emailStakeholders } = getFormatedPayloadBody();
    if (isToggleNotificationStakeholdersOn && !(0, isEmpty_1.default)(emailStakeholders)) {
        const isEmailValid = emailStakeholders.filter((email) => !(0, HelperUtils_1.validateEmail)(email))
            .length === 0;
        return isEmailValid;
    }
    return true;
};
exports.checkIsEmailValid = checkIsEmailValid;
